import React from 'react';
import { IconContext } from 'react-icons';
import { MdClose } from 'react-icons/md';
import Cookies from 'universal-cookie';

import { useAppDispatch, useAppSelector } from '../redux/store';
import { useTranslation } from 'react-i18next';
import { toggleShowMenu } from '../redux/slices/menuSlice';
import { Link } from 'react-router-dom';
import { COOKIES_KEY, GOOGLE_AUTH_URL } from '../constants';
import { setHasCookie } from '../redux/slices/authSlice';
import styles from './styles/settings.module.scss';

export const SideMenu: React.FC = () => {
  const { t } = useTranslation();

  const hasCookies = useAppSelector((state) => state.auth.hasCookies);
  const dispatch = useAppDispatch();

  const destroyCookies = () => {
    const cookies = new Cookies();
    cookies.remove(COOKIES_KEY, { path: '/' });

    dispatch(setHasCookie(false));
    dispatch(toggleShowMenu());
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.close}>
          <IconContext.Provider
            value={{
              style: { width: '34px', height: '34px', color: '#fff' },
            }}
          >
            <MdClose onClick={() => dispatch(toggleShowMenu())} />
          </IconContext.Provider>
        </div>

        <div className={styles.menu}>
          {hasCookies ? (
            <a onClick={destroyCookies} className={styles.logout}>
              {t('logout')}
            </a>
          ) : (
            <a href={GOOGLE_AUTH_URL}>{t('google')}</a>
          )}

          <Link to={'settings'} onClick={() => dispatch(toggleShowMenu())}>
            {t('settings')}
          </Link>
          <a href="#">{t('donate')}</a>
          <a href="#">{t('feedback')}</a>
        </div>
      </div>
    </>
  );
};
